export function suffixIfDoesNotExist(str: string | undefined, suffix: string) {
    return str && !str.endsWith(suffix) ? `${str}${suffix}` : str;
}

export function removeIfStartsWith(str: string | undefined, prefix: string) {
    return str && str.startsWith(prefix) ? str.split('').slice(prefix.length).join('') : str;
}

export function padStartTwoDigits(val: string | number) {
    return val.toString().padStart(2, '0');
}
